import { useState, useEffect } from "react";
import { Box, Button, CloseButton, Dialog, HStack, Portal, Text, VStack } from "@chakra-ui/react";
import LeadInterestLevelBadge from "../LeadInterestLevelBadge";

const INTEREST_LEVELS = ["Low", "Medium", "High"];

const ChangeLeadInterestLevelModal = ({ isOpen, onClose, currentInterestLevel, onSubmit, isLoading }) => {
    const [selectedLevel, setSelectedLevel] = useState(currentInterestLevel ?? null);

    useEffect(() => {
        if (isOpen) setSelectedLevel(currentInterestLevel ?? null);
    }, [isOpen, currentInterestLevel]);

    return (
        <Dialog.Root open={isOpen} onOpenChange={(e) => { if (!e.open) onClose(); }}>
            <Portal>
                <Dialog.Backdrop />
                <Dialog.Positioner p={4}>
                    <Dialog.Content
                        bg="bg.card" color="white" borderColor="border.primary" border="1px solid"
                        w={{ base: "calc(100vw - 2rem)", md: "md" }} maxW="100%" maxH="calc(100dvh - 2rem)"
                        overflowY="auto" borderRadius={12}
                    >
                        <Dialog.Body pt={6} pb={6} px={6}>
                            <Text fontWeight={700} fontSize="lg" mb={4}>Zmień poziom zainteresowania</Text>
                            <VStack align="stretch" gap={2} mb={4}>
                                <Box
                                    as="button" onClick={() => setSelectedLevel(null)}
                                    display="flex" alignItems="center" gap={3} px={3} py={2} borderRadius={8}
                                    border="1px solid" borderColor={selectedLevel === null ? "brand.400" : "border.primary"}
                                    bg={selectedLevel === null ? "rgba(26,165,255,0.08)" : "bg.secondary"}
                                    cursor="pointer" transition="all 0.15s" _hover={{ borderColor: "brand.400" }}
                                    outline="none" textAlign="left"
                                >
                                    <Text color="text.grey" fontSize="sm">Brak</Text>
                                </Box>
                                {INTEREST_LEVELS.map(level => (
                                    <Box
                                        key={level} as="button" onClick={() => setSelectedLevel(level)}
                                        display="flex" alignItems="center" gap={3} px={3} py={2} borderRadius={8}
                                        border="1px solid" borderColor={selectedLevel === level ? "brand.400" : "border.primary"}
                                        bg={selectedLevel === level ? "rgba(26,165,255,0.08)" : "bg.secondary"}
                                        cursor="pointer" transition="all 0.15s" _hover={{ borderColor: "brand.400" }}
                                        outline="none" textAlign="left"
                                    >
                                        <LeadInterestLevelBadge interestLevel={level} />
                                    </Box>
                                ))}
                            </VStack>
                            <HStack justify="flex-end" gap={2}>
                                <Button variant="ghost" size="sm" onClick={onClose} disabled={isLoading}>Anuluj</Button>
                                <Button variant="primary" size="sm" loading={isLoading} onClick={() => onSubmit(selectedLevel)}>
                                    Zapisz
                                </Button>
                            </HStack>
                        </Dialog.Body>
                        <Dialog.CloseTrigger asChild>
                            <CloseButton size="sm" position="absolute" top="2" right="2" color="text.grey" />
                        </Dialog.CloseTrigger>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Portal>
        </Dialog.Root>
    );
};

export default ChangeLeadInterestLevelModal;
